import React from 'react'
import { View, ViewStyle, StyleSheet } from 'react-native'
import { color, spacing, fontSize, fontFamily, fontWeight } from '@partipost-cm-new/app-preview/dist/Styles/Base'
import Card from '@partipost-cm-new/app-preview/dist/Components/Card'
import PartiText from '@partipost-cm-new/app-preview/dist/Components/PartiText'
import { moderateScale } from '@partipost-cm-new/app-preview/dist/Utils/Scaling'

interface TextSubmitBlockProps {
    title: string
    placeholder: string
    cardStyle?: ViewStyle
}

const TextSubmitBlock: React.FC<TextSubmitBlockProps> = ({ title, placeholder, cardStyle }) => {
    return (
        <Card cardStyle={{ ...styles.cardContainer, ...cardStyle }}>
            <View style={styles.titleContainer}>
                <PartiText style={styles.title}>{title}</PartiText>
            </View>
            <View style={styles.container}>
                <PartiText style={styles.text}>{placeholder}</PartiText>
            </View>
        </Card>
    )
}

const styles = StyleSheet.create({
    cardContainer: {
        borderRadius: moderateScale(10),
        padding: spacing.medium,
        marginBottom: moderateScale(24),
    },
    titleContainer: {
        paddingBottom: spacing.small,
        flexDirection: 'row',
    },
    title: {
        fontSize: fontSize.extraSmall,
        paddingBottom: spacing.small,
        color: color.tundora,
        fontFamily: fontFamily.copy,
        fontWeight: fontWeight.medium,
        textTransform: 'uppercase',
    },
    container: {
        justifyContent: 'center',
        alignItems: 'center',
        padding: spacing.small,
    },
    text: {
        color: color.doveGray,
    },
})

export default TextSubmitBlock
